import { useImperativeHandle, useRef } from 'react';
import { Turnstile, TurnstileInstance } from '@marsidev/react-turnstile';
import styled from 'styled-components';

const ContainerTurnstile = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  @media (max-width: 400px) {
    justify-content: start;
    overflow-x: auto;
    max-width: 100%;
  }
`;

export type InputCaptchaRef = {
  getValue: () => string;
  reset: () => void;
};

export type InputCaptchaProps = {
  captchaRef: React.RefObject<InputCaptchaRef>;
  onError: () => void;
};

export const isCaptchaDisabled = () =>
  !(process.env.NEXT_PUBLIC_TURNSTILE_IS_ACTIVE?.toLowerCase() === 'true');

export const isCaptchaValid = (ref: React.RefObject<InputCaptchaRef>) =>
  isCaptchaDisabled() || !!ref.current?.getValue();

const InputCaptcha = ({ captchaRef, onError }: InputCaptchaProps) => {
  const turnstileRef = useRef<TurnstileInstance>(null);

  useImperativeHandle(captchaRef, () => ({
    getValue: () => turnstileRef.current?.getResponse() || '',
    reset: () => turnstileRef.current?.reset(),
  }));

  if (isCaptchaDisabled()) return null;

  const siteKey = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY;

  if (!siteKey) {
    throw new Error('No turnstile site key');
  }

  return (
    <ContainerTurnstile>
      <Turnstile
        ref={turnstileRef}
        siteKey={siteKey}
        onError={onError}
        onExpire={onError}
        options={{ theme: 'light' }}
      />
    </ContainerTurnstile>
  );
};

export default InputCaptcha;
